// extracted by mini-css-extract-plugin
export default {"breakpoint_tablet_max_width_1199":"1199px","eyeCatcher_wrapper":"fas_eyeCatcher_wrapper","t_eyeCatcher":"fas_t_eyeCatcher","inner_text":"fas_inner_text","is_new":"fas_is_new"};